import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/components/Login'
import Auth from '@/components/auth/SetPassword'



import Dashboard from '@/components/start/Dashboard'
import Administrador from '@/components/administrador/Administrador'
import Menu from '@/components/administrador/menus/Menu'
import Submenus from '@/components/administrador/submenus/Submenus'
import Parametrizacion from '@/components/parametrizacion/Parametrizacion'
import ManageUsers from '@/components/users/Manage'
import CreateUsers from '@/components/users/Create'
import AdminRoles from '@/components/roles/Manage'
import CreateRoles from '@/components/roles/Create'
import Consolidation from '@/components/consolidation/Consolidation'
import TipoTerceros from '@/components/parametrizacion/tipoTerceros/TipoTerceros'
import TipoActivo from '@/components/parametrizacion/tipoActivo/TipoActivo'
import TipoContrato from '@/components/parametrizacion/tipoContrato/TipoContrato'
import TipoTasas from '@/components/parametrizacion/tipoTasas/TipoTasas'
import Tasas from '@/components/parametrizacion/tasas/Tasas'
import TipoMoneda from '@/components/parametrizacion/tipoMoneda/TipoMoneda'
import Moneda from '@/components/parametrizacion/moneda/Moneda'
import CentroCostos from '@/components/parametrizacion/centroCostos/CentroCostos'
import ParametrosContabilizacion from '@/components/parametrizacion/parametrosContabilizacion/ParametrosContabilizacion'
import Tercero from '@/components/tercero/Tercero'
import Activos from '@/components/activos/Activos'
import Contratos from '@/components/contratos/Contratos'
import ConsultarContratos from '@/components/contratos/Consultar'
import CrearContrato from '@/components/contratos/Crear'
import ModificarContrato from '@/components/contratos/ConsultarModificacion'
import TerminarContrato from '@/components/contratos/Terminar'
import Zscore from '@/components/zscore/Zscore'
// import Constantes from '@/components/zscore/constante/Constantes'
import Calificacion from '@/components/zscore/calificacion/Calificacion'
import InformacionFinanciera from '@/components/zscore/informacionFinanciera/InformacionFinanciera'
import Cierres from '@/components/cierres/Cierre'
import CierreMensual from '@/components/cierres/CierreMensual'
import Causacion from '@/components/cierres/Causacion'
import Contabilizacion from '@/components/cierres/Contabilizacion'
import ConsultaCierres from '@/components/consultaCierres/ConsultaCierres'
import ConsultaCierreMensual from '@/components/consultaCierres/ConsultaCierreMensual'
// import ConsultaCausacion from '@/components/consultaCierres/ConsultaCausacion'
import SaldosContables from '@/components/cierres/SaldosContables'
import ConsultaSaldosContables from '@/components/consultaCierres/ConsultaSaldosContables'
import ConsComprobanteContable from '@/components/consultaCierres/ConsComprobanteContable'
import ConsultaContabilizacion from '@/components/consultaCierres/ConsultaContabilizacion'
import ConsultaMesesAbiertos from '@/components/consultaCierres/ConsultaMesesAbiertos'
import ListadoCausacion from '@/components/consultaCierres/ListadoCausacion'
import Reportes from '@/components/reportes/Reportes'
import ReporteContratos from '@/components/reportes/ReporteContratos'
import ActivosPorContrato from '@/components/reportes/ActivosPorContrato'
import InformacionContratos from '@/components/reportes/InformacionContratos'
import ReportePorTercero from '@/components/reportes/ReportePorTercero'
import ReportePorContrato from '@/components/reportes/ReportePorContrato'
import ReportePorTipoActivo from '@/components/reportes/ReportePorTipoActivo'
import ReportePorTipoContrato from '@/components/reportes/ReportePorTipoContrato'
import SaldosPorCierre from '@/components/reportes/SaldosPorCierre'
import SaldosPorContratoDesHas from '@/components/reportes/SaldosPorContratoDesHas'
import Auditoria from '@/components/auditoria/Auditoria'
import FechaRegistro from '@/components/auditoria/fechaRegistro/FechaDeRegistro'
import ConsultarDetalle from '../components/contratos/ConsultarDetalle.vue'
import ConsultarActivos from '../components/contratos/ConsultarActivos.vue'
import ConsultarCuotas from '../components/contratos/ConsultarCuotas.vue'
// import Storage from "../main";
import store from '../store'
const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/administrador',
    name: 'administrador',
    component: Administrador,
    // children:[
    //   {
    //     path: '/administrador/menus',
    //     name: 'menus',
    //     component: Menu,
    //   }
    // ]
  },
  {
    path: '/submenus',
    name: 'submenus',
    component: Submenus
  },
  {
    path: '/menus',
    name: 'menus',
    component: Menu,
  },
  {
    path: '/parametrizacion',
    name: 'parametrizacion',
    component: Parametrizacion
  },
  {
    path: '/tipoterceros',
    name: 'tipoterceros',
    component: TipoTerceros
  },
  {
    path: '/tipoActivo',
    name: 'tipoActivo',
    component: TipoActivo
  },
  {
    path: '/tipoContrato',
    name: 'tipoContrato',
    component: TipoContrato
  },
  {
    path: '/tipoTasas',
    name: 'tipoTasas',
    component: TipoTasas
  },
  {
    path: '/tasas',
    name: 'tasas',
    component: Tasas
  },
  {
    path:  '/tipoMoneda',
    name: 'tipoMoneda',
    component: TipoMoneda
  },
  {
    path:  '/moneda',
    name: 'moneda',
    component: Moneda
  },
  {
    path: '/centrodecostos',
    name: 'centrodecostos',
    component: CentroCostos
  },
   {
    path: '/parametrosContabilizacion',
    name: 'parametrosContabilizacion',
    component: ParametrosContabilizacion
  },
  {
    path: '/tercero',
    name: 'tercero',
    component: Tercero
  },
  {
    path: '/activos',
    name: 'activos',
    component: Activos
  },
  {
    path: '/contratos',
    name: 'contratos',
    component : Contratos
  },
  {
    path: '/consultarcontrato',
    name: 'consultarcontrato',
    component : ConsultarContratos
  },
  {
    path: '/crearcontrato',
    name: 'CrearContrato',
    component: CrearContrato
  },
  {
    path: '/consultardetalle/:id',
    name: 'ConsultarDetalle',
    component: ConsultarDetalle
  },
  {
    path: '/consultaractivos/:contrato',
    name: 'ConsultarActivos',
    component: ConsultarActivos
  },
  {
    path: '/consultaractivos/:contrato',
    name: 'ConsultarCuotas',
    component: ConsultarCuotas
  },
  {
    path: '/modificarcontrato',
    name: 'modificarcontrato',
    component : ModificarContrato
  },
  {
    path: '/terminacioncontrato',
    name: 'terminacioncontrato',
    component : TerminarContrato
  },
  {
    path: '/zscore',
    name: 'Zscore',
    component: Zscore
  },
  // {
  //   path: '/constantes',
  //   name: 'Constantes',
  //   component: Constantes
  // },
  {
    path : '/calificacion',
    name : 'Calificacion',
    component : Calificacion
  },
  {
    path: '/informacionFinanciera',
    name: 'InformacionFinanciera',
    component: InformacionFinanciera
  },
  {
    path: '/cierres',
    name: 'Cierres',
    component: Cierres
  },
  {
    path: '/cierreMensual',
    name: 'CierresMensual',
    component: CierreMensual
  },
  {
    path: '/saldosContables',
    name: 'SaldosContables',
    component: SaldosContables
  },
  {
    path: '/causacion',
    name: 'Causacion',
    component: Causacion
  },
  {
    path: '/contabilizacion',
    name: 'Contabilizacion',
    component: Contabilizacion
  },
  {
    path: '/consultaCierres',
    name: 'ConsultaCierres',
    component: ConsultaCierres
  },
  {
    path: '/consultaCierreMensual',
    name: 'ConsultaCierreMensual',
    component: ConsultaCierreMensual
  },
  // {
  //   path: '/consultaCausacion',
  //   name: 'ConsultaCausacion',
  //   component: ConsultaCausacion
  // },
  {
    path: '/consultaSaldosContables',
    name: 'ConsultaSaldosContables',
    component: ConsultaSaldosContables
  },
  {
    path: '/consultaContabilizacion',
    name: 'ConsultaContabilizacion',
    component: ConsultaContabilizacion
  },
  {
    path: '/consComprobanteContable',
    name: 'ConsComprobanteContable',
    component: ConsComprobanteContable
  },
  {
    path: '/consultaMesesAbiertos',
    name: 'ConsultaMesesAbiertos',
    component: ConsultaMesesAbiertos
  },
  {
    path: '/listadoCausacion',
    name: 'ListadoCausacion',
    component: ListadoCausacion
  },
  {
    path: '/reportes',
    name: 'Reportes',
    component: Reportes
  },
  {
    path: '/reporteContratos',
    name: 'ReporteContratos',
    component: ReporteContratos
  },
  {
    path: '/activosporcontrato',
    name: 'ActivosPorContrato',
    component: ActivosPorContrato
  },
  {
    path: '/informacionContratos',
    name: 'InformacionContratos',
    component: InformacionContratos
  },
  {
    path: '/reporteportercero',
    name: 'ReportePorTercero',
    component: ReportePorTercero
  },
  {
    path: '/reporteporcontrato',
    name: 'ReportePorContrato',
    component: ReportePorContrato
  },
  {
    path: '/reporteportipoactivo',
    name: 'ReportePorTipoActivo',
    component: ReportePorTipoActivo
  },
  {
    path: '/reporteportipocontrato',
    name: 'ReportePorTipoContrato',
    component: ReportePorTipoContrato
  },
  {
    path: '/saldosporcierre',
    name: 'SaldosPorCierre',
    component: SaldosPorCierre
  },
  {
    path: '/saldosporcontrato',
    name: 'SaldosPorContrato',
    component: SaldosPorContratoDesHas
  },
  {
    path: '/auditoria',
    name: 'Auditoria',
    component: Auditoria
  },
  {
    path: '/fecharegistro',
    name: 'FechaRegistro',
    component: FechaRegistro
  },
  {
    path: '/users',
    name: 'users',
    component: ManageUsers,
    // beforeEnter: (to, from, next) => {
    //   if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
    //     next()
    //   }else{
    //     next({name: 'login'})
    //   }
    // }
  },
  {
    path: '/users/create',
    name: 'users-create',
    component: CreateUsers,
    beforeEnter: (to, from, next) => {
      // if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
        next()
      // }else{
      //   next({name: 'login'})
      // }
    }
  },
  {
    path: '/roles',
    name: 'roles',
    component: AdminRoles,
    // beforeEnter: (to, from, next) => {
    //   if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
    //     next()
    //   }else{
    //     next({name: 'login'})
    //   }
    // }
  },
  {
    path: '/roles/create',
    name: 'roles-create',
    component: CreateRoles,
    beforeEnter: (to, from, next) => {
      if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
        next()
      }else{
        next({name: 'login'})
      }
    }
  },
  {
    path: '/consolidation',
    name: 'consolidation',
    component: Consolidation
  },
  {
    path: '/home',
    name: 'home',
    component: Dashboard,
    // beforeEnter: (to, from, next) => {
    //   if(store.state.userRole == 'COM' || store.state.userRole == 'ADM'){
    //     next()
    //   }else{
    //     next({name: 'login'})
    //   }
    // }
  },
  {
    path: '/account',
    name: 'account',
    component: Auth
  },  
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // let expiresIn = 0;
  // if(store.state.expiration){
  // const now = new Date();
  // expiresIn = (new Date(store.state.expiration)).getTime() - now.getTime();
  // }
  if (to.name !== 'login' && to.name !== 'account' && to.name !== 'registration' && !store.state.isAuthenticated) next({ name: 'login' })
  else next()
})

export default router
